import UserType from '../constants/userType';
import { getTcnCustomerId, getUserInfo, getCustomerId } from './localStorage';

export const isMainTcncpUser = async () => {
  const tcncpCustomerId = await getTcnCustomerId();
  const customerId = await getCustomerId();
  const isRoleAdministrator = isAdministratorUser();
  return tcncpCustomerId && !customerId && isRoleAdministrator;
};

export const isAdministratorUser = async () => {
  const userInfo = await getUserInfo();
  return userInfo?.type === UserType.Administrator;
};

export const isRegularUser = async () => {
  const userInfo = await getUserInfo();
  return userInfo?.type === UserType.User;
};

export const isReadOnlyUser = async () => {
  const userInfo = await getUserInfo();
  return userInfo?.type === UserType.ReadOnly;
};

export const getUserPermissionType = (userType, tcnCustomerId, customerId) => {
  if (userType === UserType.Administrator && tcnCustomerId && !customerId) {
    return "Master User";
  } else {
    return UserType.toString(userType);
  }
};